<template>
  <div class="IberoForm">
    <div class="form-container">
      <div class="form-row">
        <div
          :id="'div_' + item.id"
          :class="[item.class]"
          class="nav"
          v-for="item of FieldsForm"
          :key="item.id"
          :v-if="item.hidden != true"
          :style="{ display: !item.hidden ? '' : 'none' }"
        >
          <div class="titleRef col-md-12">{{ item.name }}</div>
          <div class="inputRef col-md-12">
            <ValidationProvider
              :class="{ classes: true }"
              :name="item.name"
              :rules="item.validate"
              v-slot="{ classes, errors }"
            >
              <div v-if="item.type === 'password'">
                <input
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  :placeholder="item.placeholder"
                  class="form-control col-md-12"
                  type="password"
                  autocomplete="off"
                  maxlength="100"
                  :class="classes"
                />
              </div>
              <div v-else-if="item.type === 'input'">
                <input
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  :placeholder="item.placeholder"
                  class="form-control col-md-12"
                  :class="classes"
                  :maxlength="item.validate.max"
                  @keyup="executeProcess"
                  @blur="executeProcess"
                />
              </div>
              <div v-else-if="item.type === 'inputkey'">
                <input
                  autocomplete="off"
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  :placeholder="item.placeholder"
                  class="form-control col-md-12"
                  :class="classes"
                  :maxlength="item.validate.max"
                  @click="executeProcess"
                  @keyup="executeProcess"
                />
              </div>
              <div v-else-if="item.type === 'file'" class="custom-file" v-show="!item.hidden">
                <input
                    :id="item.id"
                    :placeholder="item.placeholder"
                    :idUbication="item.model"
                    class="custom-file-input col-md-12"
                    :class="classes"
                    type="file"
                    @change="executeProcess"/>
                <label class="custom-file-label" data-browse="Archivo" :for="item.id">
                    {{ item.placeholder }}
                </label>
              </div>
              <div v-else-if="item.type === 'file_detail'">
                <div class="table-responsive-sm">
                  <table class="table">
                    <tbody>
                      <tr>
                        <th width="10%" scope="row">{{ item.idFile }}</th>
                        <td width="50%">{{ item.dataFile.Nam_File }}</td>
                        <td width="20%">
                          {{ formatBytes(item.dataFile.Size, 0) }}
                        </td>
                        <td width="20%" class="text-right">
                          <a :href="item.DetURI" target="_blank">
                            <img
                              width="20"
                              height="20"
                              src="@/assets/images/detail.png"
                              class="img-fluid"
                              title="Ver Documento"
                              alt="Ver Documento"
                            />
                          </a>
                          
                          <img
                            v-if="item.delete"
                            width="20"
                            height="20"
                            src="@/assets/images/DocSend.png"
                            class="img-fluid"
                            title="Enviar Documento"
                            alt="Enviar Documento"
                            @click="fileClosedFunction(item, 'Send')"
                          />
                          <img
                            v-if="!item.delete"
                            width="20"
                            height="20"
                            src="@/assets/images/DocYes.png"
                            class="img-fluid"
                            title="Documento Enviado"
                            alt="Documento Enviado"
                          />
                          <img
                            width="20"
                            height="20"
                            src="@/assets/images/inactive.png"
                            class="img-fluid"
                            title="Eliminar Documento"
                            alt="Eliminar Documento"
                            @click="fileClosedFunction(item, 'Delete')"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-else-if="item.type === 'Select'">
                <select
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  class="form-control col-md-12"
                  :disabled="item.disabled === true"
                  @change="executeProcess"
                  :class="classes"
                >
                  <option
                    value
                    selected="selected"
                    v-if="item.placeholder !== ''"
                  >
                    {{ item.placeholder }}
                  </option>
                  <option
                    v-for="itemList of item.values"
                    v-bind:value="itemList.id"
                    :key="itemList.id"
                    :code="itemList.codVal"
                  >
                    {{ itemList.value }}
                  </option>
                </select>
              </div>

              <div v-else-if="item.type === 'Select2'">
                <select
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  class="form-control col-md-12"
                  :disabled="item.disabled === true"
                  @change="executeProcess"
                  :class="classes"
                >
                  <option
                    value
                    selected="selected"
                    v-if="item.placeholder !== ''"
                  >
                    {{ item.placeholder }}
                  </option>
                  <option
                    v-for="itemList of item.values"
                    v-bind:value="itemList.nomenclature"
                    :key="itemList.nomenclature"
                    :code="itemList.codVal"
                  >
                    {{ itemList.value }}
                  </option>
                </select>
                <span class="form-control col-md-12">{{ ModelForm[item.model] }}</span>
              </div>
            
              <div v-else-if="item.type === 'datepicker'">
                <datepicker
                  v-model="ModelForm[item.model]"
                  :bootstrap-styling="true"
                  :monday-first="true"
                  :highlighted="item.dateTimePickerOptions.highlighted"
                  :disabled-dates="item.dateTimePickerOptions.disabledDates"
                  :format="item.dateTimePickerOptions.format"
                  :placeholder="item.placeholder"
                  :language="es"
                  :name="item.name"
                  :id="item.id"
                  :input-class="classes"
                  @closed="datepickerClosedFunction(item)"
                ></datepicker>
              </div>
              <div v-else-if="item.type === 'accepted'" class="col-md-12">
                <input
                  v-model="ModelForm[item.model]"
                  type="checkbox"
                  :id="'cbox_' + item.id"
                  @change="executeProcess"
                  :class="classes"
                  :disabled="item.disabled"
                />&nbsp;
                <label
                  :for="'cbox_' + item.id"
                  v-html="item.placeholder"
                ></label>
              </div>
              <div v-else-if="item.type === 'ClearZone'"></div>
              <div v-else-if="item.type === 'informative'">
                <strong>{{ ModelForm[item.model] }}</strong>
              </div>
              <div v-else-if="item.type === 'textarea'">
                <textarea
                  v-model="ModelForm[item.model]"
                  :id="item.id"
                  :placeholder="item.placeholder"
                  class="form-control col-md-12"
                  :class="classes"
                  :maxlength="item.validate.max"
                  @keyup="executeProcess"
                  @blur="executeProcess"
                >
                </textarea>
              </div>
              <div v-else-if="item.type === 'html'">
                <div v-html="item.values"></div>
              </div>
              <div v-else-if="item.type === 'button'">
                <button
                  :id="'btn_' + item.id"
                  type="submit"
                  v-on:click="executeProcess"
                  class="btn btn-lg btn-block botonRef"
                >
                  {{ item.placeholder }}
                </button>
              </div>
              <div v-else>
                Requiere un formato correcto para el campo del formulario
              </div>
              <div :id="'error_' + item.id" class="is-invalid-form">
                {{ errors[0] }}
              </div>
            </ValidationProvider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import IberoHelpers from "@/store/helpers.js";

export default {
  name: "IberoForm",
  methods: {
    executeProcess(event) {
      this.method(event);
    },
    datepickerClosedFunction(dataref) {
      var event = new Object();
      var target = new Object();
      target.id = dataref.id;
      target.value = dataref.values;
      event.target = target;
      this.method(event);
    },
    fileClosedFunction(dataref, refEvent) {
      this.method(dataref, refEvent);
    },
    formatBytes(bytes, decimals) {
      return IberoHelpers.formatBytes(bytes, decimals);
    },
  },
  data() {
    return {
      es: es,
    };
  },
  components: {
    Datepicker,
  },
  props: {
    method: Function,
    ModelForm: Object,
    FieldsForm: Array,
  },
};
</script>

<style>
.btn:hover, .btn:focus {
color: #ffffff !important;
  background-color: #222 !important;
  border-color: #222 !important;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
  box-shadow: 10px 10px 41px -20px rgba(249,195,68,1);
}

.btn:active
{
  border-color: #A3A6AA !important;
  background-color: #A3A6AA !important;
  color: #fff;
}

.titleRef {
  font-weight: bold;
  padding-bottom: 0px;
  margin-top: 30px;
}

.btn {
  color: #000;
  background-color: #fff;
  border: 3px solid #000;
  font-size: 15px;
  font-weight: bold;
  -webkit-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  -moz-box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
  box-shadow: 10px 10px 41px -20px rgba(249, 195, 68, 1);
}

.datepicker {
  padding-bottom: 30px;
}

.is-invalid-form {
  color: red;
  height: 10px;
  font-size: 12px;
}

.custom-file-size {
  color: red;
  height: 10px;
  font-size: 12px;
}

.form-control {
  margin-top: 10px !important;
  margin-bottom: 0px !important;
}

.table {
  width: 100%;
}
.img-fluid {
  cursor: pointer;
  margin-left: 10px;
  margin-right: 10px;
}
</style>